import { UserManager, WebStorageStateStore, Log } from "oidc-client";

const config = {
  authority: process.env.VUE_APP_IDS_URL,
  client_id: process.env.VUE_APP_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_AUTOMATION_URL + "/callback.html",
  silent_redirect_uri: process.env.VUE_APP_AUTOMATION_URL + "/silent.html",
  response_type: "id_token token",
  scope: "openid profile email roles offline_access BeProductPublicApi",
  post_logout_redirect_uri: process.env.VUE_APP_AUTOMATION_URL,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true
};

const mgr = new UserManager(config);

// mgr.events.addAccessTokenExpiring(function() {
//   console.log("token expiring");
// });
//
// mgr.events.addAccessTokenExpired(function() {
//   console.log("token expired");
//   this.manager.signoutRedirect();
// });
//
mgr.events.addSilentRenewError(function(e) {
  console.log("silent renew error", e.message);
  mgr.signinRedirect({
    state: {
      redirectUrl: window.location.hash
    }
  }).catch(function(err) {
    console.log(err)
  });
});
//
// mgr.events.addUserLoaded(function(user) {
//   console.log("user loaded", user);
//   mgr.getUser().then(function() {
//     console.log("getUser loaded user after userLoaded event fired");
//   });
// });
//
// mgr.events.addUserUnloaded(function(e) {
//   console.log("user unloaded");
//   //this.manager.signinRedirect()
//   //window.location.replace("/");
// });

Log.logger = console;

export default {
  manager: mgr,
  getSessionState() {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function(user) {
        if (user == null) {
          self.signIn()
          return resolve(false)
        } else {
          return resolve(user.session_state)
        }
      }).catch(function(err) {
        console.log(err)
        return reject(err)
      });
    })
  },
  getAcessToken() {
    let self = this
    return new Promise((resolve, reject) => {
      mgr.getUser().then(function(user) {
        if (user == null) {
          self.signIn()
          return resolve(false)
        } else {
          return resolve(user.access_token)
        }
      }).catch(function(err) {
        console.log(err)
        return reject(err)
      });
    })
  },
  signIn() {
    mgr.signinRedirect({
      state: {
        redirectUrl: window.location.hash
      }
    }).catch(function(err) {
      console.log(err)
    })
  },
  signOut() {
    mgr.signoutRedirect().then(function(resp) {
      console.log('signed out', resp);
    }).catch(function(err) {
      console.log(err)
    })
  }

};
